import { RouteErrorBoundary } from "@/components/routing/RouteErrorBoundary";
import Enterprise from "@/pages/Enterprise";
import ClinicalWorkflowDetails from "@/pages/ClinicalWorkflowDetails";
import PatientAssessment from "@/pages/enterprise/PatientAssessment";
import CarePlanningEnterprise from "@/pages/enterprise/CarePlanning";
import ProgressTracking from "@/pages/assessment/ProgressTracking";
import AssessmentEfficiency from "@/pages/impact/AssessmentEfficiency";
import EarlyDetection from "@/pages/impact/EarlyDetection";
import PatientSatisfaction from "@/pages/impact/PatientSatisfaction";
import { DemoScheduleForm } from "@/components/enterprise/DemoScheduleForm";
import { ContactSalesForm } from "@/components/enterprise/ContactSalesForm";
import { lazy } from "react";

const EnterpriseImplementationGuide = lazy(() => import("@/pages/enterprise/EnterpriseImplementationGuide"));
const EnterpriseResources = lazy(() => import("@/pages/enterprise/Resources"));

export const enterpriseRoutes = [
  {
    path: "/enterprise",
    element: <Enterprise />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/enterprise/schedule-demo",
    element: <DemoScheduleForm open={true} onOpenChange={(open) => !open && window.history.back()} />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/enterprise/contact-sales",
    element: <ContactSalesForm open={true} onOpenChange={(open) => !open && window.history.back()} />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/enterprise/clinical-workflow",
    element: <ClinicalWorkflowDetails />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/enterprise/patient-assessment",
    element: <PatientAssessment />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/enterprise/care-planning",
    element: <CarePlanningEnterprise />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/enterprise/progress-tracking",
    element: <ProgressTracking />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/enterprise/implementation-guide",
    element: <EnterpriseImplementationGuide />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/enterprise/resources",
    element: <EnterpriseResources />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/impact/assessment-efficiency",
    element: <AssessmentEfficiency />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/impact/early-detection",
    element: <EarlyDetection />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/impact/patient-satisfaction",
    element: <PatientSatisfaction />,
    errorElement: <RouteErrorBoundary />,
  },
];